import { type TypedUseSelectorHook, useSelector } from 'react-redux';

import { type RootState } from '../services/serviceTypes';

/**
 * A typed version of the `useSelector` hook from React-Redux.
 *
 * This hook is already typed with the application's RootState, eliminating
 * the need to explicitly type it when selecting from the Redux store.
 *
 * @description Add the type of the new state in RootState when pulled from the Redux store
 *
 * @example
 * // Instead of:
 * // const user = useSelector((state: RootState) => state.user);
 *
 * // You can use:
 * const user = useTypedSelector(state => state.user);
 *
 * @returns The selected state from the Redux store with proper TypeScript typing
 */
const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

// eslint-disable-next-line import/prefer-default-export
export { useTypedSelector };
